import {
  TRACKER_TYPES,
} from '../analyticsConstants';

import {
  HBUS_READY_EVENT
} from '../hbus/hbusConstants';

let queuedRequestContexts = [];

function queueRequest(eventName, eventData) {
  queuedRequestContexts.push(
    {
      eventName,
      eventData,
    }
  );
}

function triggerQueuedEvents() {
  if (queuedRequestContexts) {
    queuedRequestContexts.forEach(
      ({eventName, eventData}) => {
        trackEvent(eventName, eventData);
      }
    );
  }
}

function trackEvent(eventData) {
  if(process.env.BROWSER && window){
    window.hepsiBus.send(TRACKER_TYPES.GOOGLE_ANALYTICS, eventData);
  }
}

const googleAnalyticsClient = {
  sendEventRequest(eventData) {
    return new Promise((resolve) => {
      if (window.hepsiBus) {
        trackEvent(eventData);
      } else {
        queueRequest(eventData);
      }

      resolve({data: {}});
    });
  },
};

if (process.env.BROWSER && window.addEventListener) {
  window.addEventListener(
    HBUS_READY_EVENT,
    async function() {
      if (window.hepsiBus) {
        triggerQueuedEvents();
      } else {
        queuedRequestContexts = null;
      }
    }
  );
}

export default googleAnalyticsClient;
